"use client";

import Image from "next/image";
import { Star } from "lucide-react";
import { Drawer, DrawerContent } from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
import { trackAction } from "@/lib/track-action";

const APP_STORE_URL = "https://apps.apple.com/mx/app/calii/id1492959525";

type Props = {
  open: boolean;
  onContinueInBrowser: () => void;
};

export default function AppPromptDrawer({ open, onContinueInBrowser }: Props) {
  return (
    <Drawer open={open} onOpenChange={() => {}} dismissible={false}>
      <DrawerContent>
        <div className="flex flex-col items-center px-6 pb-10 pt-2 text-center gap-4">
          <Image
            src="/calii_favicon_full_res.png"
            alt="Calii"
            width={80}
            height={80}
            className="rounded-2xl shadow-md"
          />

          <div className="flex gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
            ))}
          </div>
          <div className="text-xs text-muted-foreground">4.9/5 en Google Play y App Store con más de 1 millón de descargas</div>

          <div>
            <h2 className="text-xl font-bold text-gray-900">Calii: El súper en línea número uno de México</h2>
            <p className="mt-1 text-sm text-muted-foreground">Recibe envío gratis y 25% OFF (max. $250) en tu primer pedido con el código <span className="font-bold">WEB250</span>.</p>
          </div>

          <Button
            className="w-full bg-teal-400 hover:bg-teal-500 cursor-pointer h-12 text-base"
            asChild
          >
            <a href={"https://calii.app.link"} onClick={() => trackAction("MOBILE-CONTINUE-IN-APP", "https://calii.app.link")}>Continuar en la app</a>
          </Button>

          <Button
            variant="outline"
            className="w-full cursor-pointer h-12 text-base"
            onClick={() => { trackAction("MOBILE-CONTINUE-IN-BROWSER", window.location.pathname); onContinueInBrowser(); }}
          >
            Continuar en el navegador
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
